export const alertbody: CSSFunction = ({ theme }) => ({
  flexGrow: 1,
});
